import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { QueryClientProvider } from '@tanstack/react-query';
import keycloak, { keycloakInitOptions } from './Keycloak';
import { TimezoneProvider } from './context/TimezoneContext';
import NewApp from './NewApp';
import { queryClient } from './api/queryClient';

function App() {
  return (
    <div className="min-h-screen bg-unlisted-very-light-gray">
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={keycloakInitOptions}
      >
        <QueryClientProvider client={queryClient}>
          <TimezoneProvider>
            <BrowserRouter>
              <NewApp />
            </BrowserRouter>
          </TimezoneProvider>
        </QueryClientProvider>
      </ReactKeycloakProvider>
    </div>
  );
}

export default App;
